import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Craftsmanship from './components/Craftsmanship';
import Products from './components/Products';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="bg-[#0d1117] min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Craftsmanship />
      <Products />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}
